module.exports = __webpack_public_path__ + "static/media/ExpandArrow4.fc23fced.svg";